import { Component, Input } from '@angular/core';
import { SiqCommonModule } from '@shared/siq-common.module';

@Component({
  selector: 'app-siq-dropdown-input',
  templateUrl: './siq-dropdown-input.component.html',
  standalone: true,
  imports: [SiqCommonModule]
})
export class SiqDropdownInputComponent {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() value = '';
  @Input() description: string;

  get inputValue(): string {
    return this.value ? this.value : '';
  }
}
